// src/services/api.js
// ✅ Même logique : une seule base (sans /api en dur)
// CRA :  REACT_APP_API_BASE_URL=http://localhost:4000
// Vite:  VITE_API_BASE_URL=http://localhost:4000

import axios from "axios";

// Base serveur (sans /api)
const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_BASE_URL ||
  "https://nouzhaback-theta.vercel.app";

// Prefix API de ton backend
const API_PREFIX = "/api";

// Instance axios
const api = axios.create({
  baseURL: `${API_BASE}${API_PREFIX}`,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // cookies cross-domain si besoin
});

// Intercepteur request : injecte token + userData
api.interceptors.request.use(
  (config) => {
    // ⚠️ Ton projet utilise parfois "authToken" (adminService) et parfois "token".
    // On supporte les 2 pour éviter les bugs.
    const token =
      localStorage.getItem("authToken") ||
      localStorage.getItem("token");

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    const userJson = localStorage.getItem("user");
    if (userJson) {
      // eslint-disable-next-line no-param-reassign
      config.userData = JSON.parse(userJson);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur response : gère 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Nettoyage des 2 clés possibles
      const hadToken =
        !!localStorage.getItem("authToken") ||
        !!localStorage.getItem("token");

      if (hadToken) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        const protectedRoutes = ["/mon-compte", "/mes-reservations", "/admin"];
        const isProtectedRoute = protectedRoutes.some((route) =>
          window.location.pathname.startsWith(route)
        );

        if (isProtectedRoute) {
          window.location.href =
            "/login?redirect=" + encodeURIComponent(window.location.pathname);
        }
      }
    }

    return Promise.reject(error);
  }
);

// Helpers (optionnels)
api.isAuthenticated = () =>
  !!localStorage.getItem("authToken") || !!localStorage.getItem("token");

api.getCurrentUser = () => {
  const userJson = localStorage.getItem("user");
  return userJson ? JSON.parse(userJson) : null;
};

export default api;
